import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({ providedIn: 'root' })
export class RfpService {
  api = environment.apiUrl;
  public httpService = inject(HttpClient);

  constructor() {}
  public rfpSubmission(data: any) {
    const formData = new FormData();
    formData.append('email', data.email);
    formData.append('fullName', data.fullName);
    formData.append('projectName', data.projectName);
    formData.append('file', data.file);

    return this.httpService.post(this.api + '/rfp', formData).pipe(
      tap((response: any) => {
        return response;
      })
    );
  }
}
